export const NodeRequestIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.667 1.667v2.5m6.666-2.5v2.5m-7.5 6.666H12.5m-6.667 3.334H10m3.333-11.25c2.775.15 4.167 1.208 4.167 5.125v5.15c0 3.433-.833 5.15-5 5.15h-5c-4.167 0-5-1.717-5-5.15v-5.15c0-3.917 1.392-4.967 4.167-5.125z"
      stroke="#aab3d0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
